import { render, staticRenderFns } from "./AppleBusinessConnectSettingsCard.vue?vue&type=template&id=1c040421"
import script from "./AppleBusinessConnectSettingsCard.vue?vue&type=script&lang=ts"
export * from "./AppleBusinessConnectSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports